import axios from "axios";
import { Apis } from "constants/apis";
import { UpdatePayloadFromProfile, UpdateServiceFromProfileService } from "types/services";
import { getToken } from "utils/token";

const updatePasswordFromProfile: UpdateServiceFromProfileService = async (payload: UpdatePayloadFromProfile) => {
    const { data } = await axios.post(Apis.UPDATE_PASSWORD_PROFILE, payload, { headers: { Authorization: getToken() } })
    return data
}
export default updatePasswordFromProfile;